function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M11,13.29V3.5a.5.5,0,0,0-.5-.5,10.5,10.5,0,0,0,0,21,10.4,10.4,0,0,0,7.42-3.08.48.48,0,0,0,0-.7ZM10.5,23A9.5,9.5,0,0,1,10,4V13.5a.47.47,0,0,0,.15.35l6.71,6.71A9.43,9.43,0,0,1,10.5,23Zm13-11h-10a.5.5,0,0,0-.46.31.47.47,0,0,0,.11.54l7.07,7.07a.49.49,0,0,0,.35.15.47.47,0,0,0,.35-.15A10.38,10.38,0,0,0,24,12.5.5.5,0,0,0,23.5,12Zm-2.94,6.85L14.71,13H23A9.37,9.37,0,0,1,20.56,18.85ZM13.5,11h10a.5.5,0,0,0,.5-.5A10.51,10.51,0,0,0,13.5,0a.5.5,0,0,0-.5.5v10A.5.5,0,0,0,13.5,11ZM14,1a9.53,9.53,0,0,1,9,9H14Z"
})));

var SvgPiechart = function SvgPiechart(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPiechart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/piechart.0df3bc01.svg";
export { ForwardRef as ReactComponent };